import produce from 'immer'
import { cloneDeep } from 'lodash'
import { getType } from 'typesafe-actions'
import * as actions from './actions'
import { LoginAction, UserState } from './types'
import { initEvent } from 'Store/common/common.reducer'
import parseErrorMessage from 'helpers/parseErrorMessage'
import {
  saveAccessToken,
  removeAccessToken,
  saveActiveMerchant,
  removeActiveMerchant,
  saveUserLogin,
  removeUserLogin,
  saveStaffPermission,
  removeStaffPermission,
  getUserLogin,
} from 'helpers/account'

const initialState: UserState = {
  loginData: undefined,
  verifyTokenData: undefined,
  event: cloneDeep(initEvent),
  currentUser: {
    accessToken: '',
    activeMerchant: undefined,
    username: '',
    refreshToken: '',
  },
  myMerchants: [],
  myMerchantsevent: cloneDeep(initEvent),
  staffPermissionEvent: cloneDeep(initEvent),
}

export default function(state: UserState = initialState, action: LoginAction) {
  return produce(state, draft => {
    let response
    switch (action.type) {
      case getType(actions.loginAction.request):
      case getType(actions.staffLoginAction.request):
        draft.event = cloneDeep(initEvent)
        draft.event.IsLoading = true
        draft.loginData = undefined
        draft.currentUser.username = action.payload.username
        return draft
      case getType(actions.loginAction.success):
        response = action.payload
        draft.event.IsLoading = false
        draft.event.SubmitSuccess = true
        draft.event.MessageSuccess = 'เข้าสู่ระบบสำเร็จ'
        draft.loginData = response
        saveAccessToken(response.access_token, response.expires_in)
        saveUserLogin({ ...response, username: draft.currentUser.username })
        return draft
      case getType(actions.refreshTokenAction.success):
        response = action.payload
        draft.loginData = response
        const userInfo = getUserLogin()
        saveAccessToken(response.access_token, response.expires_in)
        saveUserLogin({ ...response, username: userInfo?.username || '' })
        return draft
      case getType(actions.staffLoginAction.success):
        response = action.payload.data
        draft.event.IsLoading = false
        draft.event.SubmitSuccess = true
        draft.event.MessageSuccess = 'เข้าสู่ระบบสำเร็จ'
        draft.loginData = response
        saveAccessToken(response.access_token, response.expires_in)
        saveUserLogin({ ...response, username: draft.currentUser.username })
        return draft
      case getType(actions.resetPasswordAction.request):
        draft.event = cloneDeep(initEvent)
        draft.event.IsLoading = true
        return draft
      case getType(actions.resetPasswordAction.success):
        response = action.payload
        draft.event.IsLoading = false
        draft.event.SubmitSuccess = true
        draft.event.MessageSuccess = 'ส่งอีเมลสำเร็จ!'
        return draft
      case getType(actions.verifyTokenAction.request):
        draft.event = cloneDeep(initEvent)
        draft.event.IsLoading = true
        draft.verifyTokenData = undefined
        return draft
      case getType(actions.verifyTokenAction.success):
        response = action.payload
        draft.event.IsLoading = false
        draft.verifyTokenData = response
        return draft
      case getType(actions.updatePasswordAction.request):
        draft.event = cloneDeep(initEvent)
        draft.event.IsLoading = true
        return draft
      case getType(actions.updatePasswordAction.success):
        response = action.payload
        draft.event.IsLoading = false
        draft.event.SubmitSuccess = true
        draft.event.MessageSuccess = 'เปลี่ยนรหัสผ่านสำเร็จ!'
        return draft
      case getType(actions.findRegisterTokenAction.request):
        draft.event = cloneDeep(initEvent)
        draft.event.IsLoading = true
        draft.registerTokenData = undefined
        return draft
      case getType(actions.findRegisterTokenAction.success):
        response = action.payload
        draft.event.IsLoading = false
        draft.registerTokenData = response
        return draft
      case getType(actions.registerAccountAction.request):
        draft.event = cloneDeep(initEvent)
        draft.event.IsLoading = true
        return draft
      case getType(actions.registerAccountAction.success):
        response = action.payload
        draft.event.IsLoading = false
        draft.event.SubmitSuccess = true
        draft.event.MessageSuccess = 'สร้างบัญชีผู้ใช้ใหม่สำเร็จ!'
        return draft
      case getType(actions.loginAction.failure):

      case getType(actions.resetPasswordAction.failure):
      case getType(actions.verifyTokenAction.failure):
      case getType(actions.updatePasswordAction.failure):
      case getType(actions.findRegisterTokenAction.failure):
      case getType(actions.registerAccountAction.failure):
        draft.event.IsLoading = false
        draft.event.SubmitError = parseErrorMessage(action.payload)
        return draft
      case getType(actions.staffLoginAction.failure):
        draft.event.IsLoading = false
        draft.event.SubmitError = 'ชื่อผู้ใช้งานหรือรหัสผ่านไม่ถูกต้อง'
        return draft
      case getType(actions.getMyMerchantsAction.request):
        draft.myMerchantsevent = cloneDeep(initEvent)
        draft.myMerchantsevent.IsLoading = true
        draft.myMerchants = []
        return draft
      case getType(actions.getMyMerchantsAction.success):
        response = action.payload
        draft.myMerchantsevent.IsLoading = false
        draft.myMerchantsevent.SubmitSuccess = true
        draft.myMerchants = response.data
        return draft
      case getType(actions.getMyMerchantsAction.failure):
        draft.myMerchantsevent.IsLoading = false
        draft.myMerchantsevent.SubmitError = parseErrorMessage(action.payload)
        return draft
      case getType(actions.getStaffPermissionAction.request):
        draft.staffPermissionEvent = cloneDeep(initEvent)
        draft.staffPermissionEvent.IsLoading = true
        removeStaffPermission()
        return draft
      case getType(actions.getStaffPermissionAction.success):
        response = action.payload
        draft.staffPermissionEvent.IsLoading = false
        draft.staffPermissionEvent.SubmitSuccess = true
        saveStaffPermission(response.data)
        return draft
      case getType(actions.getStaffPermissionAction.failure):
        draft.staffPermissionEvent.IsLoading = false
        draft.staffPermissionEvent.SubmitError = parseErrorMessage(action.payload)
        return draft
      case getType(actions.clearEventAction):
        draft.event = cloneDeep(initEvent)
        draft.myMerchantsevent = cloneDeep(initEvent)
        draft.staffPermissionEvent = cloneDeep(initEvent)
        return draft
      case getType(actions.updateCurrentUserAction):
        if (action.payload.accessToken) {
          draft.currentUser.accessToken = action.payload.accessToken
        }
        return draft
      case getType(actions.updateActiveMerchantAction):
        if (action.payload.merchant) {
          draft.currentUser.activeMerchant = action.payload.merchant
          saveActiveMerchant(action.payload.merchant)
        }
        return draft
      case getType(actions.updateActiveMerchantLogoAction):
        if (draft.currentUser.activeMerchant) {
          draft.currentUser.activeMerchant.logo = action.payload.logo
          saveActiveMerchant(draft.currentUser.activeMerchant)
        }
        return draft
      case getType(actions.logoutAction):
      case getType(actions.refreshTokenAction.request):
        if (action.type === getType(actions.refreshTokenAction.request)) {
          const checkuserInfo = getUserLogin()
          const validateUser = checkuserInfo?.username && checkuserInfo?.username !== ''
          if (validateUser) {
            return draft
          }
          console.log('Auto logout (because no have user info)')
        }
        draft.myMerchants = []
        draft.currentUser.accessToken = ''
        draft.currentUser.activeMerchant = undefined
        removeAccessToken()
        removeActiveMerchant()
        removeUserLogin()
        removeStaffPermission()
        return draft
      default:
        return state
    }
  })
}
